function initPercyTestHelper() {
  const urlParams = new URLSearchParams(window.location.search);
  const percyTest = urlParams.get("percy_test");
  if (percyTest === null || percyTest === "") {
    return;
  }

  if (percyTest === "cart-drawer") {
    addToCartOpenDrawer("43506420941067", 2);
  } else if (percyTest === "quick-add-to-cart") {
    setTimeout(() => {
      document.querySelector(".product-card-add").click();
    }, 2000);
  }

  // Hide Klaviyo and Cookie Banner if percy is active
  const percyCSS = `
    .pd-cookie-banner-window {
      display: none !important;
    }

    .needsclick {
      display: none !important;
    }
    
  `;

  var styleSheet = document.createElement("style");
  styleSheet.textContent = percyCSS;
  document.head.appendChild(styleSheet);
}

initPercyTestHelper();
